<!--
	作者：offline
	时间：2019-04-15
	描述：报警事件下拉适配
-->
<style scoped>
    .expand-row{
        margin-bottom: 16px;
    }
</style>
<template>
    <div>
        <Row>
        	<Col span="6" >
                <span>日期</span>
            </Col>
            <Col span="6" >
                <span>工况气量（m3）</span>
            </Col>
            <Col span="6" >
                <span>标况气量（m3）</span>
            </Col>
            <Col span="6" >
                <span>用气金额（元）</span>
            </Col>
        </Row>
    	<Row v-for="item in [1,2,3,4,5,6,7,8,9,10,11,12]" :key="item" v-if="rowData['record'+item+'StandardFlow'] != undefined">
            <Col span="6" >
                <span>{{ rowData['record'+item+'Time'] }}</span>
            </Col>
            <Col span="6" >
                <span>{{ rowData['record'+item+'Flow'] }}</span>
            </Col>
            <Col span="6" >
                <span>{{ rowData['record'+item+'StandardFlow'] }}</span>
            </Col>
            <Col span="6" >
                <span>{{ rowData['record'+item+'cost'] }}</span>
            </Col>
        </Row>
    </div>
</template>
<script>
    export default {
        props: {
            row: Object
        },
        data(){
        	return {
        		rowData : this.row
        	};
        }
    };
</script>